import type { FormSchemaDashboardRow } from './formSchemaDashboardTypes'

export function formSchemaHeaderGradient(seed: number): string {
  const hue = Math.abs(seed * 47) % 360
  const hue2 = (hue + 40) % 360
  return `linear-gradient(135deg, hsl(${hue}, 42%, 38%) 0%, hsl(${hue2}, 48%, 28%) 100%)`
}

export function filterFormSchemaDashboardRows(
  rows: FormSchemaDashboardRow[],
  search: string,
): FormSchemaDashboardRow[] {
  const q = search.trim().toLowerCase()
  return rows.filter(row => {
    const name = (row.name ?? '').toLowerCase()
    const desc = (row.description ?? '').toLowerCase()
    return !q || name.includes(q) || desc.includes(q)
  })
}
